import React, {useState} from 'react';
import {Alert, Badge, Button, Media} from 'reactstrap';
import ReactTooltip from "react-tooltip";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import {MdDelete} from 'react-icons/md';

let commonStrings = new LocalizedStrings(common_strings);

const StudentSimpleRow = (props) => {
    const [visible, setVisible] = useState(true);

    const onDismiss = () => setVisible(false);
    return (
        <tr>
            <th scope="row">
                <Media className="align-items-center">
                    <a
                        className="avatar mr-3"
                        onClick={e => e.preventDefault()}
                    >
                        <img
                            alt="..."
                            src={props.client && props.client.photo ? props.client.photo : require("assets/img/icons/common/generic-person-white.svg").default}
                        />
                    </a>
                    <span>
                        {props.client && props.client.name ? props.client.name : ""}
                    </span>
                </Media>
            </th>
            <ReactTooltip/>
            <td className="text-right align-content-end">

                <div>
                    <Button
                        className="btn-icon ct-example-tooltip-static"
                        color="warning"
                        data-type="error"
                        data-tip={commonStrings.remove}
                        onClick={e => props.deleteClient(e, props.client)}>
                        <MdDelete/>
                    </Button>
                </div>
            </td>
        </tr>
    )
};

export default StudentSimpleRow;